module.exports = __webpack_public_path__ + "static/img/cajamitras.69aed7f1.svg";